export default __webpack_public_path__ + "static/media/Level10.cd58d029.svg";